"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var classes_1 = require("../utils/classes");
var Search = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? 'Search our help centre...' : _b, _c = _a.type, type = _c === void 0 ? 'search' : _c, className = _a.className, props = __rest(_a, ["placeholder", "type", "className"]);
    return (react_1.default.createElement("input", __assign({ className: classnames_1.default(classes_1.addClassName('search-input'), 'transition-shadow shadow focus:shadow-lg appearance-none block w-full rounded py-5 px-6 leading-tight focus:outline-none', className), type: type, placeholder: placeholder }, props)));
};
exports.default = Search;
//# sourceMappingURL=Search.js.map